<template>
    <div class="list_nav_wrap toggle-nav">
        <h1 class="list_nav_title">
            <label>{{ keyName }}</label>
        </h1>
        <div class="sc-option" data-ui="dropdown" id="brand_option" style="z-index: 994;">
            <div class="sc-option-hd"
                @click="show = true">
                <div class="sc-option-content">
                    {{ activeName }}
                </div>
                <div class="sc-option-action">
                    <i></i>
                </div>
            </div>
            <ul v-if="show"
                class="sc-option-list" style="top: 25px;">
                <li v-for="item in list">
                    <a @click="doSelect(item.value)"
                    :id-data="item.value">
                        {{ item.name }}
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import urlUtil from '@souche-f2e/chunyan-util/url_util/url_util.js';
    const locationObj = urlUtil.initByLocation();
    let formBean = window._qiwa.page_global.formBean;
    export default {
        data() {
            return {
                key: 'emissionStandard',
                keyName: '排放标准',
                show: false,
                activeName: formBean.emissionStandardName || '请选择排放标准',
                list: [{
                    value: 2,
                    name: '国二及以上'
                }, {
                    value: 3,
                    name: '国三及以上'
                }, {
                    value: 4,
                    name: '国四及以上'
                }, {
                    value: 5,
                    name: '国五及以上'
                }, {
                    value: false,
                    name: '不限'
                }]
            };
        },
        methods: {
            doSelect(value) {
                if (value) {
                    locationObj.s(this.key, value).s('index', null).go();
                } else {
                    locationObj.s(this.key, null).s('index', null).go();
                }
            }
        },
        mounted() {
            let $ = window.$;
            $('body').click((event) => {
                if (!$(event.target).closest('.sc-option').length) {
                    this.show = false;
                }
            });
        }
    };
</script>

<style lang="less" scoped>
    a {
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// NavStandard.vue?15d1bac1